import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import {
  CreditCard,
  Bookmark,
  LogOut,
} from "lucide-react";
import { dictionary } from "../utils/dictionary";
import { SettingsCard } from "../components/cards/SettingCard";

const SettingsPage = () => {
  const { language, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = useCallback(() => {
    logout();
    navigate("/");
  }, [logout, navigate]);

  const settingsOptions = [
    {
      icon: CreditCard,
      label: dictionary["integrations"][language],
      onClick: () => navigate("/integrations"),
    },
    {
      icon: Bookmark,
      label: dictionary["manage-membership"][language],
      onClick: () => navigate("/membership"),
    },
    {
      icon: LogOut,
      label: dictionary["logout"][language],
      rightElement: (
        <button
          onClick={handleLogout}
          className="px-8 py-2 rounded-lg font-semibold transition-all duration-200
            text-[#6A6A6A] border border-gray-300
            group-hover:bg-white/20 group-hover:text-white group-hover:border-white/40 group-hover:backdrop-blur-sm"
        >
          {dictionary["go-out"][language]}
        </button>
      ),
    },
  ];

  return (
    <div className="flex flex-col px-4 md:justify-center md:max-w-[510px] md:mx-auto md:min-h-screen">
      <div className="w-full flex items-center justify-between mb-6 md:mb-8 md:max-w-[510px] md:mx-auto">
        <h1 className="text-xl md:text-2xl font-bold text-gray-900">
          {dictionary["settings"][language]}
        </h1>
      </div>

      <div className="w-full flex flex-col gap-4 md:gap-6 md:max-w-[510px] md:mx-auto">
        {settingsOptions.map((option, idx) => (
          <SettingsCard
            key={idx}
            icon={option.icon}
            label={option.label}
            onClick={option.onClick}
            rightElement={option.rightElement}
          />
        ))}
      </div>
    </div>
  );
};

export default SettingsPage;
